

























import ISkill from "@/Models/Skill/ISkill";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class SkillsAndEducation extends Vue
{
    private skills: ISkill[] = [
        {Icon: "mdi-web", Text: "Vue"},
        {Icon: "mdi-web", Text: "Vuetify"},
        {Icon: "mdi-database", Text: "MongoDB"},
        {Icon: "mdi-database", Text: "SQL"},
        {Icon: "mdi-web", Text: "C# ASP.NET Core"},
        {Icon: "mdi-cellphone", Text: "Xamarin"},
    ];
}
